import React from "react";
import "./SpendAnalyticsBadge.scss";

const SpendAnalyticsBadge = ({ variant = "message", className = "" }) => {
  const classes = ["sa-badge", `sa-badge--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return <div className={classes}>SA</div>;
};

export default SpendAnalyticsBadge;